/* eslint-disable
camelcase,
jsx-a11y/anchor-is-valid,
jsx-a11y/click-events-have-key-events,
jsx-a11y/no-static-element-interactions */
import React, { ReactElement, useCallback } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { ArrowRightShape } from "@themuse/design-system";
import { triggerSnowplowClickEvent } from "@themuse/snowplow-js-client";
import { useAppState } from "hooks/AppContext";
import { useFeatureFlagsState } from "hooks/FeatureFlagsContext";
import { getPathParts, setQueryParam } from "utils/url";
import styles from "./ContentWell.module.scss";
import { ArticleCardList } from "./ArticleCardList";
import { EmployeeCardList } from "./EmployeeCardList";
import { JobCardList } from "./JobCardList";

const VIEW_MORE_LINK_TEXT = "VIEW MORE ARTICLES";

const Description = (): ReactElement => {
    const { company } = useAppState();
    if (company?.description?.length < 20) return null;
    return (
        <>
            <h2 className={styles.headings}>Who We Are</h2>
            <div className={styles.contentBody}>{company?.description}</div>
        </>
    );
};
Description.displayName = "Description";

const ContentWell = (): ReactElement => {
    const router = useRouter();
    const { FEATURE_FLAG_EMPLOYEE_STORIES } = useFeatureFlagsState();

    const getTabLink = useCallback((slug: string) => {
        const { pathname, query } = getPathParts(router.asPath);
        const linkQuery = setQueryParam({ key: "tab", query, value: slug });
        return { pathname, query: linkQuery };
    }, [router.asPath]);

    const handleViewArticlesClick = () => {
        triggerSnowplowClickEvent({
            sp_click_button_text: null,
            sp_click_button_type: null,
            sp_click_component: "link",
            sp_click_component_tile_type: "article",
            sp_click_insert_type: null,
            sp_click_link_text: VIEW_MORE_LINK_TEXT,
            sp_click_position: "articles",
            sp_click_target_page_section: "profile",
            sp_tile_entity_id: "",
            sp_tile_type: "article",
        });
    };

    return (
        <div className={styles.contentWell}>
            <Description />
            <h2 className={styles.headings}>Hiring Now</h2>
            <JobCardList />
            {FEATURE_FLAG_EMPLOYEE_STORIES && (
                <EmployeeCardList
                    className={styles.contentCardList}
                    title="Hear from the team"
                    viewMore={(
                        <p className={styles.viewMore}>
                            <Link href={getTabLink("team")}>
                                <a className={styles.viewMoreLink}>
                                    VIEW MORE EMPLOYEES
                                    <ArrowRightShape />
                                </a>
                            </Link>
                        </p>
                    )}
                />
            )}
            <ArticleCardList
                className={styles.contentCardList}
                size={3}
                title="Articles"
                trackingLocation="main"
                viewMore={(
                    <p className={styles.viewMore}>
                        <Link href={getTabLink("articles")}>
                            <a
                                className={styles.viewMoreLink}
                                onClick={handleViewArticlesClick}
                            >
                                {VIEW_MORE_LINK_TEXT}
                                <ArrowRightShape />
                            </a>
                        </Link>
                    </p>
                )}
            />
        </div>
    );
};
ContentWell.displayName = "ContentWell";

export { ContentWell };
